var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"menu-button relative",on:{"click":_vm.insertQrCode}},[_c('app-icon',{staticClass:"w-5 h-5",attrs:{"name":"technology-qr-code-scan"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }